import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock-closed",
  "use": "lock-closed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"lock-closed\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 11V9a5 5 0 1110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H7a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H9V9a3 3 0 116 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol